import { html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map';

import { TeComponent } from './common/te-component';
import { InputSkin } from './common/component-types';
import './te-icon';
import './input/te-input-text';

/**
 * Search Component
 *
 * @slot - Default slot for search spotlight
 */
@customElement('te-search')
export class TeSearch extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .search-wrapper {
        position: relative;
      }

      ::slotted(*) {
        display: none;
      }

      .search-wrapper:focus-within ::slotted(*) {
        display: flex;
      }

      .search-wrapper .force-show::slotted(*) {
        display: flex;
      }

      .search-wrapper .force-hide::slotted(*) {
        display: none;
      }

      .icon-wrapper {
        background: transparent;
        position: absolute;
        z-index: 1;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ];

  /** Search input value */
  @property({ type: String, attribute: 'value' }) value = '';
  /** Spotlight is visible */
  @property({ type: Boolean }) isSpotlightOpen?: boolean;
  /** Text before any value is received */
  @property({ type: String }) placeholderText = 'Search...';
  /** Exact width of search */
  @property({ type: String }) width = '384px';
  /** Basic color scheme of search */
  @property({ type: String }) skin: InputSkin = 'default';

  @state() input?: HTMLInputElement;

  updated() {
    this.input = this?.shadowRoot
      ?.querySelector('te-input-text')
      ?.shadowRoot?.querySelector('div>div>input') as HTMLInputElement;
    if (this.input) {
      this.input.style.paddingLeft = '40px';
    }
  }

  getSpotlightClass() {
    if (this.isSpotlightOpen === true) return 'force-show';
    else if (this.isSpotlightOpen === false || this.value === '') return 'force-hide';
    else return '';
  }

  getWrapperStyle() {
    return {
      width: `${this.width}`,
    };
  }

  render() {
    return html`
      <div class="search-wrapper" style=${styleMap(this.getWrapperStyle())}>
        <div
          class="icon-wrapper"
          @click=${() => {
            if (this.input) this.input.focus();
          }}
        >
          <te-icon size="14" name="search"></te-icon>
        </div>
        <te-input-text
          id="${this.testId}"
          placeholderText=${this.placeholderText}
          .value=${this.value}
          skin=${this.skin}
          @teChange=${this.forwardCustomEvent}
        ></te-input-text>
        <slot class=${this.getSpotlightClass()}></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-search': TeSearch;
  }
}
